import { API_V4 } from "@/services/config/auth-axios";

class walletService {
  changeEmail(data) {
    return API_V4.post("/verification/email/update" , data);
  }
  getEmailOtp(data) {
    return API_V4.post("/verification/email/send-otp" , data);
  }

  changeMobile(data) {
    return API_V4.post("/verification/mobile/update" , data);
  }
  getMobileOtp(data) {
    return API_V4.post("/verification/mobile/send-otp" , data);
  }

  removeGoogleAuth(data) {
    return API_V4.post(`/verification/otp/google2fa/remove` , data);
  }
  getGoogleAuthOtp() {
    return API_V4.post(`/verification/otp/google2fa/send-otp`, null , {
        headers: {
          "Content-Type": "application/json"
        }
      });
  }
}

export default new walletService();
